import { useQuery } from "@tanstack/react-query";
import adminApi from "../../api/adminApi";

export const useGetAllCourse = (page: number, limit: number) => {
    return useQuery({
        queryKey: ["courses", page, limit],
        queryFn: () => adminApi.getAllCourse({ page, limit }),
    });
};
